import { environmentHttpClient as httpClient } from "client/Api/httpClient";
import {
	CommunityPostImageViewModel,
	CommunityPostStatisticsModel
} from "./communityPostViewer";
import { UserIdentityModel } from "../UserProfile/service";
import { CommunityPostOptionsModel, CommunityViewModel } from "./communityPosts";
import {
	CommunityCoverImageViewModel,
	CommunityKind,
	CommunityUserInfo
} from "./community";
import { HubCommentModel, HubLinkedDocumentViewModel } from "../Hub/common";

export type CommunityPostPreviewModel = {
	id: number;
	message: string | null;
	images: readonly CommunityPostImageViewModel[];
	createdOn : Date | string;
	modifiedOn : Date | string;
	createdBy: UserIdentityModel | null;
	community: CommunityViewModel;
	isEditable: boolean;
	isFollowing: boolean;
	statistics: CommunityPostStatisticsModel;
	comments: LazyLoadPageResult<HubCommentModel>;
	hasPoll: boolean;
	linkedDocuments: readonly HubLinkedDocumentViewModel[];
};

export type CommunityPostPagingInformationModel = {
	id: number;
	createdOn: Date | string;
};

export function list(
	communityId: number | "my-feed",
	afterPost: CommunityPostPagingInformationModel | null,
	amount: number | null,
	signal?: AbortSignal
): Promise<LazyLoadPageResult<CommunityPostPreviewModel>> {
	return httpClient.get<LazyLoadPageResult<CommunityPostPreviewModel>>(
		`UiApi/Communities/${communityId ?? "my-feed"}/Posts`,
		{
			afterPost,
			amount
		},
		{ signal }
	);
}

export type CommunityInFeed = {
	id: number;
	kind: CommunityKind;
	name: string;
	isMember: boolean;
	isFollowing: boolean;
	canPost: boolean;
};

export type CurrentCommunityInfo = {
	id: number;
	kind: CommunityKind;
	name: string;
	description: string | null;
	image: CommunityCoverImageViewModel | null;
	membersCount: number;
	userInfo: CommunityUserInfo;
};

export type FeedPageModel = {
	options: CommunityPostOptionsModel;
	communitiesInFeed: readonly CommunityInFeed[];
	currentCommunity: CurrentCommunityInfo | null;
};

export function getFeedPageInfo(
	communityId: number | "my-feed",
	signal: AbortSignal
): Promise<FeedPageModel> {
	return httpClient.get<FeedPageModel>(
		`UiApi/Communities/${communityId}/Feed`,
		undefined,
		{ signal }
	);
}

export type NewCommunityItemViewModel = {
	id: number;
	name: string;
	image: CommunityCoverImageViewModel | null;
};

export function listNewCommunities(
	signal: AbortSignal
): Promise<readonly NewCommunityItemViewModel[]> {
	return httpClient.get<readonly NewCommunityItemViewModel[]>(
		`UiApi/Communities/NewCommunities`,
		undefined,
		{ signal }
	);
}
